import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name"];
import { Button } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Submit = props => {
  var {
      keyname,
      name = 'submit'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (!elmProps.children) {
    elmProps.children = 'Log in';
  }
  return /*#__PURE__*/_jsx(Button, _extends({
    type: "submit"
  }, elmProps, {
    name: name,
    keyname: keyname
  }));
};